import { render, staticRenderFns } from "./CategoriaRepresentativaForm.vue?vue&type=template&id=bdd741fe&scoped=true&"
import script from "./CategoriaRepresentativaForm.vue?vue&type=script&lang=js&"
export * from "./CategoriaRepresentativaForm.vue?vue&type=script&lang=js&"
import style0 from "./CategoriaRepresentativaForm.vue?vue&type=style&index=0&id=bdd741fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd741fe",
  null
  
)

export default component.exports